<div class="w-full flex flex-col gap-[6px]">
    <span class="font-[800] text-[14px] text-[#6B7280]">{{ label }}</span>
   
    <textarea
    (keyup)="onInputChange($event)"
    placeholder="{{ placeholder }}"
    [(ngModel)]="inputValue"
    class="h-[75px] py-[15px] focus:outline-none font-[400] text-[14px] text-[#374151] placeholder:text-[#6B7280] bg-[#F4F5F7] rounded-[5px] px-[13px]"
    >

    </textarea>

    <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
  </div>